import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import config from "@/config";

Vue.use(Router);
const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

/* Con esto actualizo el store con el paso actual para que los watchers lo sepan */
router.beforeEach((to, from, next) => {
  to.meta.config = config.getPasoProperties(to.name);

  // Tengo que intentar retener en este paso ?
  if (to.meta.config.askLeave) {
    window.onbeforeunload = function () {
      return "Desea salir del sitio?";
    };
  } else {
    window.onbeforeunload = null;
  }

  to.meta.name = to.name;
  store.dispatch("doRoute", to);
  next();
});

// router.replace({ path: '/', redirect: '/' })
export default router;
